import axios from "axios";
import { config } from "./rest";

export const axiosInstance = axios.create({
  baseURL: config.API_URL,
  headers: {
    Authorization: process.env.REACT_APP_API_KEY
  }
});

